import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { ReclamationActionDetailType } from 'constants.js';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import TransporteurSelect from 'components/Shared/TransporteurSelect';

import { ReclamationActionDetailCodes } from 'constants.js';

import stringHelper from 'utils/stringHelper';

const styles = theme => ({
    detailValue: {
        paddingLeft: theme.spacing(4)
    },

    input: {
        marginTop: 10
    }
});


class DemandeEnlevementValideeDialogContent extends React.Component {

    constructor(props) {
        super(props);

        let state = {
            transporteurId: props.transporteurId,
            numeroPiece: '',
        };


        this.state = state;
    }

    componentDidMount() {
        this.props.onChange(null);
    }

    getActionData(newState) {
        const { action } = this.props;

        if (newState.transporteurId === '') {
            return null;
        }

        if (stringHelper.isNullOrWhitespace(newState.numeroPiece)) {
            return null;
        }

        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Transporteur,
                type: ReclamationActionDetailType.TransporteurId,
                libelle: 'Transporteur',
                position: 0,
                valeurInteger: newState.transporteurId
            }, {
                code: ReclamationActionDetailCodes.NumeroPiece,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Numéro d\'ordre d\'enlèvement chez le transporteur',
                position: 1,
                valeurString: newState.numeroPiece
            }]
        };


        return actionData;
    }

    handleChange = (event) => {

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    render() {
        const { classes } = this.props;
        const { transporteurId, numeroPiece } = this.state;


        return (
            <DialogContent>
                <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
                <Typography variant="body2" gutterBottom className={classes.detailValue}>Réaffecter ce dossier après-vente au groupe "Traitement des retours"</Typography>


                <TransporteurSelect value={transporteurId} onChange={this.handleChange} all={false} isRequired />

                <TextField className={classes.input} id="numeroPiece" name="numeroPiece" label="Indiquer le numéro d'ordre d'enlèvement chez le transporteur" type="text" value={numeroPiece} onChange={this.handleChange} fullWidth required />

            </DialogContent>
        );
    }
}

DemandeEnlevementValideeDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    transporteurId: PropTypes.number.isRequired
};

export default withStyles(styles)(DemandeEnlevementValideeDialogContent);